// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `auto-complete-venues {
  --line-height: 32px;
  --input-bg-color: rgba(255, 255, 255, 0.808);
}
auto-complete-venues .auto-complete {
  resize: vertical;
  width: 100%;
  padding: 0px;
  margin: 0px 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: white;
  position: relative;
  min-height: var(--line-height);
}
auto-complete-venues .auto-complete .title {
  padding: 2px;
  border-radius: var(--border-radius);
  border: 1px solid rgba(0, 0, 0, 0);
  color: black;
  display: inline-block;
}
auto-complete-venues .auto-complete .title:hover {
  cursor: pointer;
  background-color: rgba(214, 214, 214, 0.5);
  border: 1px solid rgba(218, 218, 218, 0.7);
}
auto-complete-venues .cdk-virtual-scroll-content-wrapper {
  overflow: hidden;
}
auto-complete-venues .remove-item-icon {
  line-height: 18px;
  padding: 3px;
  vertical-align: middle;
  display: inline-block;
}
auto-complete-venues .remove-item-icon:hover {
  color: rgb(170, 0, 0);
}
auto-complete-venues auto-complete .itemInfo {
  width: 70%;
}
auto-complete-venues auto-complete .itemImage {
  max-width: 100%;
}
auto-complete-venues auto-complete .item {
  height: 50px;
  width: 100%;
  border: none;
  box-sizing: border-box;
  z-index: 2;
}
auto-complete-venues auto-complete .item p {
  margin-top: 10px;
}
auto-complete-venues .auto-complete .item {
  z-index: 2;
  position: relative;
  display: inline-block;
}
auto-complete-venues .single-select {
  width: 100%;
  background-color: var(--input-bg-color);
  border-radius: var(--border-radius);
}
auto-complete-venues .single-select .selected-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--line-height);
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
}
auto-complete-venues .single-select .remove-item-icon {
  position: absolute;
  line-height: 24px;
  right: 0px;
}
auto-complete-venues .single-select .item, auto-complete-venues .single-select .title {
  display: block;
  width: 100%;
  box-sizing: border-box;
  opacity: 1;
  position: relative;
}
auto-complete-venues .single-select .noItems hr {
  margin-top: 0;
  margin-bottom: 0;
}
auto-complete-venues .single-select .queryInput {
  position: relative;
  width: 100%;
  min-width: 100px;
  background-color: var(--input-bg-color);
  margin-bottom: 0px;
  margin-top: 0px;
  height: 30px;
  font-family: Gothic;
  line-height: var(--line-height);
  font-size: 16px;
  padding-left: 5px;
  box-sizing: border-box;
  opacity: 0;
  cursor: text;
  border-radius: var(--border-radius);
}
auto-complete-venues .single-select .itemList {
  position: absolute;
  top: 20px;
  width: 100%;
  z-index: 3;
  box-sizing: border-box;
  border: 1px solid rgb(14, 14, 14);
  box-shadow: 0 0 5px rgba(50, 50, 50, 0.4), 0 0 1px rgba(20, 20, 20, 0.4);
}
auto-complete-venues .single-select .itemList h4 {
  font-size: 16px;
}
auto-complete-venues .single-select .auto-complete .title {
  color: black;
  width: 100%;
  display: block;
  box-sizing: border-box;
}
auto-complete-venues .single-select.input-focused .title {
  opacity: 0;
  transition: 200ms ease-in;
}
auto-complete-venues .single-select.input-focused .queryInput {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/auto-complete/auto-complete-venues/auto-complete-venues.component.scss"],"names":[],"mappings":"AAAA;EAEI,mBAAA;EACA,4CAAA;AAAJ;AAEI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EAEA,uBAAA;EACA,kBAAA;EACA,8BAAA;AADR;AAII;EACI,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,YAAA;EACA,qBAAA;AAFR;AAKI;EACI,eAAA;EACA,0CAAA;EACA,0CAAA;AAHR;AAMI;EACI,gBAAA;AAJR;AAOI;EACI,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;AALR;AAQI;EACI,qBAAA;AANR;AASI;EACI,UAAA;AAPR;AAUI;EACI,eAAA;AARR;AAWI;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AATR;AAWQ;EACI,gBAAA;AATZ;AAaI;EACI,UAAA;EACA,kBAAA;EACA,qBAAA;AAXR;AAcI;EAEI,WAAA;EACA,uCAAA;EACA,mCAAA;AAbR;AAeQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AAbZ;AAeQ;EACI,kBAAA;EACA,iBAAA;EACA,UAAA;AAbZ;AAgBQ;EACI,cAAA;EACA,WAAA;EAEA,sBAAA;EACA,UAAA;EACA,kBAAA;AAfZ;AAoBY;EACI,aAAA;EACA,gBAAA;AAlBhB;AAsBQ;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,mCAAA;AApBZ;AAuBQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,iCAAA;EACA,wEAAA;AArBZ;AAuBY;EACI,eAAA;AArBhB;AAyBQ;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;AAvBZ;AA4BQ;EACI,UAAA;EACA,yBAAA;AA1BZ;AA6BQ;EACI,UAAA;AA3BZ","sourcesContent":["auto-complete-venues {\n    \n    --line-height: 32px;\n    --input-bg-color: rgba(255, 255, 255, 0.808);\n\n    .auto-complete {\n        resize: vertical;\n        width: 100%;\n        padding: 0px;\n        margin: 0px 0;\n        border: 1px solid rgba(255, 255, 255, 0.3);\n        // background: rgba(255,255,255,0.03);\n        background-color: white;\n        position: relative;\n        min-height: var(--line-height);\n    }\n    \n    .auto-complete .title {\n        padding: 2px;\n        border-radius: var(--border-radius);\n        border: 1px solid rgba(0, 0, 0, 0);\n        color: black;\n        display: inline-block;\n    }\n    \n    .auto-complete .title:hover {\n        cursor: pointer;\n        background-color: rgba(214, 214, 214, 0.5);\n        border: 1px solid rgba(218, 218, 218, 0.7);\n    }\n    \n    .cdk-virtual-scroll-content-wrapper {\n        overflow: hidden;\n    }\n    \n    .remove-item-icon {\n        line-height: 18px;\n        padding: 3px;\n        vertical-align: middle;\n        display: inline-block;\n    }\n    \n    .remove-item-icon:hover {\n        color: rgb(170, 0, 0);\n    }\n    \n    auto-complete .itemInfo {\n        width: 70%;\n    }\n    \n    auto-complete .itemImage {\n        max-width: 100%;\n    }\n    \n    auto-complete .item {\n        height: 50px;\n        width: 100%;\n        border: none;\n        box-sizing: border-box;\n        z-index: 2;\n\n        p {\n            margin-top: 10px;\n        }\n    }\n    \n    .auto-complete .item {\n        z-index: 2;\n        position: relative;\n        display: inline-block;\n    }\n    \n    .single-select {\n        // min-width: 210px;\n        width: 100%;\n        background-color: var(--input-bg-color);\n        border-radius: var(--border-radius);\n\n        .selected-item {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: var(--line-height);\n            z-index: 2;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n        .remove-item-icon {\n            position: absolute;\n            line-height: 24px;\n            right: 0px;\n        }\n        \n        .item, .title {\n            display: block;\n            width: 100%;\n            // height: 100%;\n            box-sizing: border-box;\n            opacity: 1;\n            position: relative;\n        }\n        \n        .noItems {\n            // margin-top: 14px;\n            hr {\n                margin-top: 0;\n                margin-bottom: 0;\n            }\n        }\n\n        .queryInput {\n            position: relative;\n            width: 100%;\n            min-width: 100px;\n            background-color: var(--input-bg-color);\n            margin-bottom: 0px;\n            margin-top: 0px;\n            height: 30px;\n            font-family: Gothic;\n            line-height: var(--line-height);\n            font-size: 16px;\n            padding-left: 5px;\n            box-sizing: border-box;\n            opacity: 0;\n            cursor: text;\n            border-radius: var(--border-radius);\n        }\n        \n        .itemList {\n            position: absolute;\n            top: 20px;\n            width: 100%;\n            z-index: 3;\n            box-sizing: border-box;\n            border: 1px solid rgb(14, 14, 14);\n            box-shadow: 0 0 5px rgba(50,50,50,.4), 0 0 1px rgba(20,20,20,.4);\n\n            h4 {\n                font-size: 16px;\n            }\n        }\n        \n        .auto-complete .title {\n            color: black;\n            width: 100%;\n            display: block;\n            box-sizing: border-box;\n        }\n    }\n    \n    .single-select.input-focused {\n        .title {\n            opacity: 0;\n            transition: 200ms ease-in;\n        }\n\n        .queryInput {\n            opacity: 1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
